module.exports = __webpack_public_path__ + "media/images/emoticons/snowboard-858a36cfec23573ae088635a966555ad.gif";